import styles from "./ViewHotspotAudio.module.css";
import { MdVolumeUp, MdCancel } from "react-icons/md";
import { useAppStore } from "../../../hooks/store/useAppStore";
import { currentHotspotSelector } from "../../../hooks/store/getters";
import { useState, useEffect } from 'react';
import { pauseHotspotAudioSelector } from "../../../hooks/store/getters";


const ViewHotspotAudio = () => {
    const [showAudio, setShowAudio] = useState(false);   
    const currentHotspot = useAppStore(currentHotspotSelector);
    const { audio } = currentHotspot;
    const pauseHotspotAudio = useAppStore(pauseHotspotAudioSelector);
    
    const openAudio = () => setShowAudio(true);
    const hideAudio = () => setShowAudio(false);
    
    useEffect(() => { 
        let playAudio;
        if(audio.url && !pauseHotspotAudio && !showAudio) {
            playAudio = new Audio(audio.url);
            playAudio.play();
        } 
        else if((audio.url && pauseHotspotAudio) || showAudio) {
            playAudio && playAudio.pause();
        }

        return () => {
            playAudio && playAudio.pause();
        }
        // eslint-disable-next-line
    }, [pauseHotspotAudio, showAudio])

    if (!audio.url) return null;
    
    return (
        <div className={styles.hotspotAudio}>
            {
                (audio.file || audio.url) && (
                    <span className={styles.icon}>
                       <MdVolumeUp className="text-info" onClick={openAudio} />
                    </span>
                )
            }
            {
                showAudio && (
                    <div className={styles.hotspotAudioPlayer}>
                        <div className={styles.audioCloseBtn} onClick={hideAudio}>
                            <MdCancel />
                        </div>
                        <audio controls autoPlay>
                            <source src={audio.file} />
                            <source src={audio.url} />
                        </audio>
                    </div>
                )
            }
        </div>
    );
};

export default ViewHotspotAudio;